import React, {useState} from "react";
import cookie from "react-cookies";
import {Button, Input, message, Modal} from "antd";
import {getHostAddress} from "../../Tool/UtileFun";


export function DeleteButton(props){

    const role = "role"
    const [messageModal,setMessageModal] = useState(false)


    const messageModalShow=()=>{
        setMessageModal(true)
    }
    const messageModalOk=()=>{
        deleteFileOnClick()
        setMessageModal(false)
    }
    const messageModalCancel=()=>{
        setMessageModal(false)
    }

    const deleteOtherFileResources=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/deleteById",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //删除后刷新
                props.Event()
            })
            .catch(error => message.error("error"+error));
    }

    const deleteFile=()=>{
        if (cookie.load(role) === "teacher") {
            return <Button type="link" danger onClick={messageModalShow}>删除</Button>
        }
    }

    const deleteFileOnClick=()=>{
        console.log(props)
        deleteOtherFileResources(props.id)
    }

    return(
        <>
            <Modal title="编辑视频"
                   visible={messageModal}
                   onOk={messageModalOk}
                   onCancel={messageModalCancel}
                   okText={"确定"}
                   cancelText={"取消"}
            >
                <p>你确定要删除这个文件吗？</p>
            </Modal>
            {deleteFile()}
        </>
    )
}
